import type { Point } from "./types";

export function getIntermediatePoint(start: Point, end: Point, length: number): Point {
  const diffX = end.x - start.x;
  const diffY = end.y - start.y;
  const distance = Math.sqrt(diffX * diffX + diffY * diffY);

  if (distance <= length) {
    return end;
  }

  const ratio = length / distance;

  return {
    x: start.x + diffX * ratio,
    y: start.y + diffY * ratio,
  };
}

export function drawPath(shiftX = 0, shiftY = 0, initialPath = "") {
  let path = initialPath;
  return {
    moveTo(point: Point) {
      path += ` M ${point.x + shiftX},${point.y + shiftY}`;
      return this;
    },
    arcTo(fromPoint: Point, toPoint: Point, absolutePoint: Point) {
      path += ` C`
        .concat(` ${fromPoint.x + shiftX},${fromPoint.y}`)
        .concat(` ${absolutePoint.x + shiftX},${absolutePoint.y}`)
        .concat(` ${toPoint.x + shiftX},${toPoint.y}`);
      return this;
    },
    curveTo(point: Point, ...args: Point[]) {
      const points = args.map((item) => `${item.x + shiftX},${item.y}`).join(" ");
      path += ` C`.concat(` ${points}`).concat(` ${point.x + shiftX},${point.y}`);
      return this;
    },
    quadraticCurveTo(controlPoint: Point, toPoint: Point) {
      path += ` Q`
        .concat(` ${controlPoint.x + shiftX},${controlPoint.y}`)
        .concat(` ${toPoint.x + shiftX},${toPoint.y}`);
      return this;
    },
    lineTo(point: Point) {
      path += ` L ${point.x + shiftX},${point.y}`;
      return this;
    },
    finish() {
      return path;
    },
  };
}
